import Footer from "./section/Footer";
import Header from "./section/Header";
import InfoBeasiswa from "./section/InfoBeasiswa";
import Tahapan from "./section/Tahapan";

function App() {

  return (
    <>
      <Header />
      <InfoBeasiswa />
      <Tahapan />
      <Footer />
    </>
  );
}

export default App;
